import { createAction } from "redux-actions";
export const fetchInitialSettings = createAction("INITIAL/FETCH_SETTINGS");
export const successInitialSettings = createAction("INITIAL/SUCCESS_SETTINGS");
export const errorInitialSettings = createAction("INITIAL/ERROR_SETTINGS");
export const toggleInitialPopup = createAction("INITIAL/TOGGLE_POPUP");

export const setInitialLoading = createAction("INITIAL/SET_INITIAL_LOADING_STATUS");

export const setBrokerLink = createAction("INITIAL/SET_BROKER_LINK");
